export default "__VITE_ASSET__DkP2pwjj__"